import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import moment from "moment-timezone";
import { NEW } from "./NEW";

const notifications = [
  {
    message: `Fixed issue with claiming prizes with new event`,
    date: "March 11, 2021 01:00:00 GMT+0530",
  },
  {
    message: `Fixed issues with SCHS GK and SCHS Customised run. These should work fine
    now.`,
    date: "March 10, 2021 01:00:00 GMT+0530",
  },
  {
    message: `New tasks for Customised CHS, ECHS. SCHS tasks like open SCHS maps and
    Customised SCHS are not tested as no live SCHS since changes.`,
    date: "March 04, 2021 01:00:00 GMT+0530",
  },
  {
    message: `ECHS Issue with Gryphon has been fixed. CHS score log changes and
    experimental feature SCHS Map Open Task are added. Please contact
    incase of issues.`,
    date: "February 16, 2021 01:00:00 GMT+0530",
  },
];

export default function(props) {
  const d2 = new Date();
  return (
    <TaskDialog heading={"Notifications"} fullScreen={true}>
      <ul style={{ padding: "10px" }}>
        <li style={{ padding: "5px", fontWeight: "bold", color: "red" }}>
          Please logout and login again if you havent since the reboot*
        </li>
        {notifications.map((log) => {
          var d1 = log.date;
          var diff = moment(d2).diff(d1, "days");
          return (
            <li style={{ padding: "5px", fontWeight: "bold" }}>
              {log.message}
              {diff < 7 ? <NEW /> : ""}
            </li>
          );
        })}
      </ul>
    </TaskDialog>
  );
}
